var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconV = function SvgIconV(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 24",
    strokeWidth: 0,
    className: "icon__v_svg__v"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1,
    d: "M24.71 1.084a.844.844 0 0 0-1.192.208L9.978 20.81l-7.59-7.75a.842.842 0 0 0-1.209 0 .886.886 0 0 0 0 1.236l8.114 8.285a.839.839 0 0 0 .766.495.85.85 0 0 0 .698-.368L24.914 2.3a.886.886 0 0 0-.203-1.217"
  })));
};
export { SvgIconV as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNiAyNCIgc3Ryb2tlLXdpZHRoPSIwIiBjbGFzcz0idiI+CiAgICA8cGF0aCBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIxIgogICAgICAgICAgZD0iTTI0LjcxIDEuMDg0YS44NDQuODQ0IDAgMCAwLTEuMTkyLjIwOEw5Ljk3OCAyMC44MWwtNy41OS03Ljc1YS44NDIuODQyIDAgMCAwLTEuMjA5IDAgLjg4Ni44ODYgMCAwIDAgMCAxLjIzNmw4LjExNCA4LjI4NWEuODM5LjgzOSAwIDAgMCAuNzY2LjQ5NS44NS44NSAwIDAgMCAuNjk4LS4zNjhMMjQuOTE0IDIuM2EuODg2Ljg4NiAwIDAgMC0uMjAzLTEuMjE3Ii8+Cjwvc3ZnPgo=";